import { render, staticRenderFns } from "./AppAccordionListBlock.vue?vue&type=template&id=40b7a28a&scoped=true"
import script from "./AppAccordionListBlock.vue?vue&type=script&lang=js"
export * from "./AppAccordionListBlock.vue?vue&type=script&lang=js"
import style0 from "./AppAccordionListBlock.vue?vue&type=style&index=0&id=40b7a28a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b7a28a",
  null
  
)

export default component.exports